<template>
    <div class="flex flex-col flex-1" data-page>
        <Banner />

        <Blocks />

        <div class="mt-auto">
            <PreFooter />
        </div>

        <Popup />
    </div>
</template>

<script setup>
    const entryStore = useEntryStore()

    const { entry, seomatic } = storeToRefs(entryStore)

    // load page data
    await entryStore.loadEntry('__home__')

    const seoTitle = computed(() => {
        const titleContainer = JSON.parse(seomatic.value?.metaTitleContainer ?? '{}')
        return get(titleContainer, 'title.title', entry.value?.title)
    })

    const metaTags = computed(() => {
        return flatMap(JSON.parse(seomatic.value?.metaTagContainer ?? '[]'))
    })

    useSeoMeta({
        title: seoTitle.value,
    })

    useHead({
        meta: metaTags.value
    })

</script>
